import { render, staticRenderFns } from "./BannersTab.vue?vue&type=template&id=cd4d10d6&scoped=true"
import script from "./BannersTab.vue?vue&type=script&lang=js"
export * from "./BannersTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BannersTab.vue?vue&type=style&index=1&id=cd4d10d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4d10d6",
  null
  
)

export default component.exports